import {
    EDIT_INVOICE_STATUS_Failed,
    EDIT_INVOICE_STATUS_Loading,
    EDIT_INVOICE_STATUS_Success,
    EDIT_INVOICE_STATUS_Reset
} from "../types";
const initialState = {
    loading: false,
    error: null,
    invoice : null , 
    status: null,
};

export const EditInvoiceStatusReducer = (
    state = initialState,
    action: { type: any; loading: any; status: any; error: any , payload: any; }
) => {
    switch (action.type) {
        case EDIT_INVOICE_STATUS_Loading:
            return {
                ...state,
                loading: action.loading,
            };
        case EDIT_INVOICE_STATUS_Success:
            return {
                ...state,
                loading: false,
                status: action.status,
                invoice:action.payload , 
                error: null,
            };
        case EDIT_INVOICE_STATUS_Failed:
            return {
                ...state,
                loading: false,
                status: null,
                invoice:null , 
                error: action.error,
            };
        case EDIT_INVOICE_STATUS_Reset:
            return initialState;
        default:
            return state;
    }
};
